import React from 'react'
import { AuthParams } from '@/utils/authentication'
import { useEffect, useMemo, useState } from 'react'
import {
  IconDashboard,
  IconSettings,
  IconMindMapping,
  IconRobot,
  IconSend,
  IconSubscribed,
  IconCodepen,
  IconBranch,
  IconDesktop,
  IconClockCircle,
  IconFile,
  IconSwap,
  IconStorage,
  IconSearch,
  IconTool,
  IconSafe,
  IconSync,
  IconDriveFile,
} from '@arco-design/web-react/icon'
import { getConfiguration } from './store/slices/userSlice'
import { useSelector } from 'react-redux'
import { useMountedState } from './hooks/useMountedState'
import { cloneDeep } from './utils/tools'
import { applyDynamicDetailRouteConfig } from './dynamicDetailRouteConfig'

export type IRoute = AuthParams & {
  id?: string
  name: string
  nameEn?: string
  key: string
  path?: string
  breadcrumb?: boolean
  children?: IRoute[]
  ignore?: boolean
  Icon?: any
  iconName?: string
  permission?: string
  noCache?: boolean
  dynamic?: boolean
  detailPath?: string
  detailFormRoute?: string
  detailActionTitles?: Record<string, { name: string; nameEn?: string }>
  dynamicDetail?: any
}

export const routes: IRoute[] = [
  {
    // name: 'menu.dashboard.workplace',
    name: '工作台',
    nameEn: 'Workplace',
    key: 'dashboard/workplace',
    Icon: IconDashboard,
    ignore: true,
  }
]

export const generatePermission = (role: string) => {
  const actions = role === 'admin' ? ['*'] : ['read']
  const result = {}
  routes.forEach((item) => {
    if (item.children) {
      item.children.forEach((child) => {
        result[child.name] = actions
      })
    }
  })
  return result
}
const getIcon = (iconName) => {
  switch (iconName) {
    case 'IconDashboard':
      return IconDashboard
    case 'IconSettings':
      return IconSettings
    case 'IconMindMapping':
      return IconMindMapping
    case 'IconRobot':
      return IconRobot
    case 'IconSend':
      return IconSend
    case 'IconSubscribed':
      return IconSubscribed
    case 'IconCodepen':
      return IconCodepen
    case 'IconBranch':
      return IconBranch
    case 'IconDesktop':
      return IconDesktop
    case 'IconClockCircle':
      return IconClockCircle
    case 'IconFile':
      return IconFile
    case 'IconSwap':
      return IconSwap
    case 'IconStorage':
      return IconStorage
    case 'IconSearch':
      return IconSearch
    case 'IconTool':
      return IconTool
    case 'IconSafe':
      return IconSafe
    case 'IconSync':
      return IconSync
    case 'IconDriveFile':
      return IconDriveFile
    default:
      break
  }
}

export const getRoutes = (configuration: any): IRoute[] => {
  const travel = (route) => {
    //校验权限
    let children
    if (route.children && route.children.length > 0) {
      children = []
      for (let i = 0; i < route.children.length; i++) {
        const child = route.children[i]
        const newchild = travel(child)
        if (newchild) children.push(newchild)
      }
    }
    if (!route.path) route.path = undefined
    const Icon = getIcon(route.iconName)
    const rst = applyDynamicDetailRouteConfig({ ...route, Icon, children })
    return rst
  }
  if (!configuration?.menuTrees) return routes
  const cloneroutes = cloneDeep({
    name: '0',
    key: '0',
    children: [...routes, ...configuration.menuTrees],
  })
  const rootRoute = travel(cloneroutes)
  let rst = rootRoute?.children
  if (rst && rst.length > 0) {
    const roles = configuration?.currentUser?.roles
    if (!(roles && roles.find((c) => c == 'admin'))) {
      rst = rst.filter((c) => !c.children || c.children.length > 0)
    }
  }
  return rst
}

const useRoute = (): [IRoute[], string] => {
  const configuration = useSelector(getConfiguration)
  const [permissionRoute, setPermissionRoute] = useState(routes)
  const isAmounted = useMountedState()
  useEffect(() => {
    if (!isAmounted()) return
    const newRoutes = getRoutes(configuration)
    setPermissionRoute(newRoutes)
  }, [configuration])

  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0]
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key
      return firstRoute
    }
    return ''
  }, [permissionRoute])

  return [permissionRoute, defaultRoute]
}

export default useRoute

